import { HandySvg } from "handy-svg";
import AIModel from "../AIModel/AIModel";
import NegativePrompt from "../NegativePrompt/NegativePrompt";
import PromptWeight from "../PromptWeight/PromptWeight";
import Sampler from "../Sampler/Sampler";
import Seed from "../Seed/Seed";
import Steps from "../Steps/Steps";
import styles from "./ExtendedSettings.module.scss";

const ExtendedSettings = ({ settings, dictionary, isLoading, changeSettings, style, isAdaptive, isOpen, toggleOpen }) => {
	return (
		<div className={styles.settings_wrapper}>
			<button
				id="toggle-settings"
				className={`${styles.header} ${isOpen ? styles.open : ""}`}
				aria-label="toggle extended settings"
				data-name={dictionary["advanced_settings"] || "Extended settings"}
				onClick={toggleOpen}
			>
				<HandySvg src={"/avatar_gen/toggle_extended_settings.svg"} width={45} height={45} className={styles.toolsIcon} />

				<span className={styles.title}>{dictionary["extended_settings"] || "Extended settings"}</span>
				<HandySvg src={"/workspace/profile/profile_arrow.svg"} width={13} height={8} className={styles.arrowIcon} />
			</button>
			{isOpen && (
				<div className={styles.content} id="settings">
					<AIModel style={style} activeItem={settings.model} dictionary={dictionary} isLoading={isLoading} changeSettings={changeSettings} />
					<NegativePrompt style={style} dictionary={dictionary} isLoading={isLoading} changeSettings={changeSettings} defaultValue={settings.negative_prompt} />
					<Seed style={style} dictionary={dictionary} isLoading={isLoading} changeSettings={changeSettings} />
					<Sampler style={style} activeItem={settings.sampler} dictionary={dictionary} isLoading={isLoading} changeSettings={changeSettings} />
					<PromptWeight style={style} dictionary={dictionary} isLoading={isLoading} changeSettings={changeSettings} isAdaptive={isAdaptive} />
					<Steps style={style} dictionary={dictionary} isLoading={isLoading} changeSettings={changeSettings} isAdaptive={isAdaptive} />
				</div>
			)}
		</div>
	);
};

export default ExtendedSettings;
